/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../../.kubb/ToZod.ts";
import type {
  GetApiV1PersonSharedTagsForPerson200,
  GetApiV1PersonSharedTagsForPerson400,
  GetApiV1PersonSharedTagsForPerson401,
  GetApiV1PersonSharedTagsForPerson500,
  GetApiV1PersonSharedTagsForPersonQueryParams,
  GetApiV1PersonSharedTagsForPersonQueryResponse,
} from "../../types/personSharedController/GetApiV1PersonSharedTagsForPerson.ts";
import { dropDownRepositoryResponseSchema } from "../dropDownRepositoryResponseSchema.ts";

export const getApiV1PersonSharedTagsForPersonQueryParamsSchema = z
  .object({
    personId: z.optional(z.coerce.number().int()),
    includeTagIds: z.optional(z.array(z.coerce.number().int())),
  })
  .optional() as unknown as ToZod<GetApiV1PersonSharedTagsForPersonQueryParams>;

/**
 * @description (OK) Resposta com os dados solicitados.
 */
export const getApiV1PersonSharedTagsForPerson200Schema = z.array(
  z.lazy(() => dropDownRepositoryResponseSchema),
) as unknown as ToZod<GetApiV1PersonSharedTagsForPerson200>;

/**
 * @description (Bad Request) Requisição em formato incorreto ou com dados faltantes.
 */
export const getApiV1PersonSharedTagsForPerson400Schema =
  z.any() as unknown as ToZod<GetApiV1PersonSharedTagsForPerson400>;

/**
 * @description (Unauthorized) Você não está autorizado a acessar este recurso.
 */
export const getApiV1PersonSharedTagsForPerson401Schema =
  z.any() as unknown as ToZod<GetApiV1PersonSharedTagsForPerson401>;

/**
 * @description (Internal Server Error) Erro interno.
 */
export const getApiV1PersonSharedTagsForPerson500Schema =
  z.any() as unknown as ToZod<GetApiV1PersonSharedTagsForPerson500>;

export const getApiV1PersonSharedTagsForPersonQueryResponseSchema = z.lazy(
  () => getApiV1PersonSharedTagsForPerson200Schema,
) as unknown as ToZod<GetApiV1PersonSharedTagsForPersonQueryResponse>;
